export const PURCHASE_TYPE = {
	NEW: "subscription",
	SUBSCRIPTION: "subscription",
	RENEW: "renew",
	ADDON: "addon",
};

export const PURCHASE_ERRORS = {
	NOT_FOUND: "errors.NOT_FOUND",
	PURCHASE_FAILED: "errors.PURCHASE_FAILED",
	UNPROCESSABLE_ENTITY: "errors.UNPROCESSABLE_ENTITY",
	SERVER_INTERNAL: "errors.SERVER_INTERNAL",
	AMOUNT_TOO_SMALL: "errors.AMOUNT_TOO_SMALL",
};

export const isPurchaseFail = error => error?.type === PURCHASE_ERRORS.PURCHASE_FAILED;

export const isCurrentPlanPrice = (price, subscription) =>
	price.newPlanCode === subscription.planCode;

export const isNewPlanPrice = (price, subscription) => price.newPlanCode !== subscription.planCode;
